export default "/static/yokogawa_cq1_tiny.png";